<app-modal title="Recebimento" [form]="form" (save)="onSave($event)">
  <form [formGroup]="form">
    <div class="tds-row">
      <app-input
        label="Senha"
        formControlName="senha"
        maxLength="10"
      ></app-input>

      <app-input
        label="Celular"
        formControlName="celular"
        maxLength="19"
      ></app-input>

      <app-select
        label="Local *"
        [options]="data.localList"
        formControlName="local"
      ></app-select>
    </div>

    <div class="tds-row">
      <div class="checkboxes-container">
        <tds-checkbox formControlName="critico" checkboxId="critico-checkbox">
          <div slot="label">Crítico</div>
        </tds-checkbox>
        <tds-checkbox formControlName="milkrun" checkboxId="milkrun-checkbox">
          <div slot="label">Milkrun</div>
        </tds-checkbox>
      </div>
    </div>
  </form>
</app-modal>
